import '@vuepic/vue-datepicker/dist/main.css'

import {createApp} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'

// Глобальный обработчик ошибок загрузки модулей
window.addEventListener('error', (event) => {
    if (event.message.includes('Loading module') ||
        event.message.includes('Importing a module script failed')) {

        console.warn('Обнаружена ошибка загрузки модуля, возможно нужно обновление');
        window.location.reload();
    }
});

// Обработка отклоненных промисов
window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message?.includes('module') ||
        event.reason?.message?.includes('import')) {
        window.location.reload();
    }
});

// Импортируем Bootstrap CSS и JS
import '@/assets/bootstrap-custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Импортируем Bootstrap Icons
import '@fortawesome/fontawesome-free/css/all.css';
import 'flag-icons/css/flag-icons.css'

import '@/assets/main.css';
import '@/assets/rtl.css';
import {IMaskDirective} from 'vue-imask';

import {initSocketListener} from "@/infrastructure/notifications_listener.js";
import {i18n} from "@/infrastructure/translations.js";
import {useOnlineUsersStore} from "@/stores/OnlineUsersStore.js";
import {useAccountStore} from "@/stores/AccountStore.js";
import {useClinicsStore} from "@/stores/ClinicsStore.js";
import {useContractsStore} from "@/stores/ContractsStore.js";
import {useMessagesStore} from "@/stores/MessagesStore.js";
import {useConversationsStore} from "@/stores/ConversationsStore.js";
import {useConversationMessagesStore} from "@/stores/ConversationMessagesStore.js";
import {useThemesStore} from "@/stores/ThemesStore.js";
import {useColorModeStore} from "@/stores/ColorModeStore.js";
import * as Sentry from "@sentry/vue";
import {setupTimezoneSync, consumeApiToken, removeApiTokenFromUrl} from "@/infrastructure/session_bootstrap.js";

initSocketListener();

const app = createApp(App)

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN || "",
    sendDefaultPii: true,
    integrations: [
        Sentry.replayIntegration()
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.directive('imask', IMaskDirective);
app.use(createPinia())
useColorModeStore().initialize()

setupTimezoneSync()
await consumeApiToken()
await useOnlineUsersStore().initializeStore()

try {
    await useAccountStore().initializeStore()
} catch (e) {
    console.error('Failed to initialize account store', e)
}

app.use(router)
app.use(i18n)

// Ensure token is removed from URL after router initialization
removeApiTokenFromUrl()

// Монтируем приложение сразу, чтобы избежать белого экрана при ошибках инициализации сторов
app.mount('#app')

const stores = [useThemesStore(), useClinicsStore(), useContractsStore(), useMessagesStore(), useConversationsStore(), useConversationMessagesStore()]
for (const store of stores) {
    try {
        console.log('Initializing store', store)
        await store.initializeStore();
    } catch (e) {
        console.error('Failed to initialize store', store, e)
    }
}
